<template>
  <div class="fillform" v-loading.fullscreen.lock="loading" v-loading="loading">
<p>苏 格 兰 学 院 听 课 记 录 表</p>
      <div class="mainHeader">
       <div class="oneline">
          <el-form :inline="true"  :model="formInline" class="demo-form-inline">
          <el-form-item label="授课教师">
              <el-input v-model="formInline.teacher" placeholder="授课教师"></el-input>
          </el-form-item>
          <el-form-item label="所在单位">
              <el-input v-model="formInline.teacherUnit" placeholder="教师所在单位"></el-input>
          </el-form-item>
                  <el-form-item label="教师职称">
              <el-input v-model="formInline.teacherTitle" placeholder="教师职称"></el-input>
          </el-form-item>
          <el-form-item label="年龄层次">
              <el-select v-model="formInline.teacherAgeLevel" placeholder="年龄层次">
              <el-option label="老(>55)" value="55"></el-option>
              <el-option label="中(35-55)" value="35"></el-option>
              <el-option label="青(20-35)" value="20"></el-option>
              </el-select>
          </el-form-item>
          
          </el-form>
      </div>
  
      <div class="oneline">
          <el-form :inline="true"  :model="formInline" class="demo-form-inline">
          <el-form-item label="课程名称">
              <el-input v-model="formInline.courseTitle" placeholder="课程名称"></el-input>
          </el-form-item>
          <el-form-item label="课程类型">
              <el-select v-model="formInline.courseType" placeholder="课程类型">
              <el-option label="公共基础课" value="class1"></el-option>
              <el-option label="专业基础课" value="class2"></el-option>
              <el-option label="专业课" value="class3"></el-option>
              <el-option label="实验课" value="class4"></el-option>
              <el-option label="实习实训" value="class5"></el-option>
              </el-select>
          </el-form-item>
          <!-- <el-form-item>
              <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item> -->
          </el-form>
      </div>
      
  
     
      <div class="oneline">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="授课日期">
              <el-input v-model="formInline.lecturesData" placeholder="X年　 X月 X日 星期X 第X周"></el-input>
          </el-form-item>
          <el-form-item label="授课班级">
              <el-input v-model="formInline.lecturesClass" placeholder="授课班级"></el-input>
          </el-form-item>
            <el-form-item label="授课地点">
              <el-input v-model="formInline.lecturesAddress" placeholder="授课地点"></el-input>
          </el-form-item>
          <el-form-item label="授课节次">
              <el-select v-model="formInline.section" placeholder="当天第几节次">
              <el-option label="8:00-8:45" value="1"></el-option>
              <el-option label="9:00-9:45" value="2"></el-option>
              <el-option label="10:00-10:45" value="3"></el-option>
              <el-option label="11:00-11:45" value="4"></el-option>
              <el-option label="13:00-13:45" value="5"></el-option>
              <el-option label="14:00-14:45" value="6"></el-option>
              <el-option label="15:00-15:45" value="7"></el-option>
              <el-option label="16:00-16:45" value="8"></el-option>
  
              </el-select>
          </el-form-item>
          
          </el-form>
      </div>
  
  
     <div class="metainfoFeedback">
          <!-- <p>课程主要内容</p> -->
          <el-form>
            
           <el-form-item label="课程主要内容"> 
             
                  <el-input   type="textarea"  style="width:1050px"  :rows="3" oninput="if(value.length>513)value=value.slice(0,513)"   placeholder="请输入课程主要内容（可多行，512字内）"   v-model="formInline.lecturesContent"> </el-input>
            </el-form-item>
          </el-form>
     </div>


    </div>

           <div class="actionButton" v-loading="loading">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <!-- <el-divider></el-divider> -->
              <el-button type="primary" @click="downs">临时保存</el-button>
              <el-button type="primary" @click="dialogVisible=true">报告预览</el-button>
              <el-button type="primary" @click="onSubmit">确认提交</el-button>
              <el-button type="primary" @click="reset">清空再填</el-button>
              <!-- <el-button type="primary" @click="clear">取消</el-button> -->
              
  
          </el-form>
      </div>
     <div class="assessformTeacher" v-loading="loading">
         <div class="leftform_T">
             <div style="padding-top:350px">
              <span class="textvert">教师授课情况</span>
               <!-- <input class="multiinput" placeholder="placeholder"> </input> -->
        </div>
        </div>
        
          
             <div class="midform_T">
                  <div style="padding-top:20px;padding-left:40px;padding-bottom:20px">
              <p>教学态度</p></div>
              <!-- <el-divider></el-divider> -->
                 <div style="padding-top:130px;padding-left:40px">
                <p>教学内容</p></div>
                <!-- <el-divider></el-divider> -->
                   <div style="padding-top:180px;padding-left:40px">
                  <p>教学方法</p></div>
                  <!-- <el-divider></el-divider> -->
                     <div style="padding-top:180px;padding-left:40px">
                    <p>教学效果</p></div>
                     <!-- <el-divider></el-divider> -->
                         <div style="padding-top:80px;padding-left:40px">
                    <p>老师综合</p></div>
               <!-- <input class="multiinput" placeholder="placeholder"> </input> -->
             
             </div>
  
              
            <div class="Rightform_T">
                <div class="oneline" v-loading="loading">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="尊重学生，治学严谨">
                          <el-radio-group v-model="formInline.respectStudents">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment1" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
               <div class="oneline">
                  <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                      <el-form-item label="讲课有热情、精神饱满">
                          <el-radio-group v-model="formInline.teacheringZeal">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment2" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  <el-divider></el-divider>
                  </div>
                <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="教学目标明确、进度适宜">
                          <el-radio-group v-model="formInline.target">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment3" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
               <div class="oneline">
                  <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                      <el-form-item label="观点正确、表达清晰">
                          <el-radio-group v-model="formInline.viewpoint">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment4" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                 
                  </div>
               <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="内容充实，信息量大、重点突出、注意介绍本学科研究和发展动态">
                          <el-radio-group v-model="formInline.enrich">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment5" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                   <el-divider></el-divider>
                  </div>
               <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="理论联系实际、善于启发思维">
                          <el-radio-group v-model="formInline.practical">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment6" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
               <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="能够实现师生互动、课堂气氛活跃">
                          <el-radio-group v-model="formInline.interaction">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment7" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
                 
               <div class="oneline">
                  <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                      <el-form-item label="能有效利用各种教学媒体">
                          <el-radio-group v-model="formInline.rationalUtilization">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment8" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                   <el-divider></el-divider>
                  </div>
               <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="学生理解和掌握了教学内容">
                          <el-radio-group v-model="formInline.understand">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment9" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
             <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="学生相关能力得到培养和提高">
                      <el-radio-group v-model="formInline.capacity">
                      <el-radio label="好"></el-radio>
                      <el-radio label="较好"></el-radio>
                      <el-radio label="一般"></el-radio>
                      <el-radio label="差"></el-radio>
                      </el-radio-group>
                   </el-form-item>
                  <el-form-item>
                      <el-input v-model="formInline.comment10" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>
                  </el-form-item>
                  
                  </el-form>
                    <el-divider></el-divider>
           </div>
                       <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="对教师授课情况的综合评价">
                          <el-radio-group v-model="formInline.instructionComprehensive">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment11" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
  
  
        </div> 
      </div>
  
     <div class="assessformstudent"  v-loading="loading" >
          <div class="leftform_S">
                  <div style="padding-top:80px;padding-left:50px">
              <p>学生上课情况</p>
               <!-- <input class="multiinput" placeholder="placeholder"> </input> -->
          </div>
           </div>
           <div class="Rightform_S">
                     <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="遵守纪律，不迟到、不早退、出勤率高、课堂秩序良好">
                          <el-radio-group v-model="formInline.discipline">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment12" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
  
              <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="认真听课、记笔记">
                          <el-radio-group v-model="formInline.lectures">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment13" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
  
            <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label="对课堂内容感兴趣，积极思考，听课率高">
                          <el-radio-group v-model="formInline.think">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment14" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
              </div>
  
             <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item  label="对学生上课情况的综合评价" class="item"  >
                          <el-radio-group v-model="formInline.listenComprehensive">
                              <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment15" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
              </div>
  
          </div>
      </div>
        
       <div class="assessformTeacher" v-loading="loading">
          <div class="leftform_All">
                <div style="padding-top:0px;padding-left:50px">
              <p>总体评价</p>
               <!-- <input class="multiinput" placeholder="placeholder"> </input> -->
          </div>
          </div>
           <div class="Rightform_All">
                
       <div class="oneline">
                  <el-form :inline="true" :model="formInline" class="demo-form-inline">
                      <el-form-item label=" ">
                          <el-radio-group v-model="formInline.evaluateComprehensive">
                              <el-radio label="优"></el-radio> <el-radio label="良"></el-radio> <el-radio label="中"></el-radio> <el-radio label="差"></el-radio>
                          </el-radio-group>
                      </el-form-item>
                      <el-form-item>                     <el-input v-model="formInline.comment16" oninput="if(value.length>255)value=value.slice(0,255)" placeholder="补充评论（可选,254字内）"></el-input>                </el-form-item>
                  </el-form>
                  </div>
           </div>
           </div>
  
      <div class="metainfoFeedback" v-loading="loading">
      <el-form>
           <el-form-item label="存在问题及改进建议">
               
                  <el-input   type="textarea"  style="width:1100px"  :rows="3"  oninput="if(value.length>513)value=value.slice(0,513)"   placeholder="请输入存在问题及改进建议（可多行，512字内）"   v-model="formInline.problem"> </el-input>
          </el-form-item>
     </el-form>
         
          
     </div>
    <div class="mainHeader">
       <div class="oneline" v-loading="loading">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <!-- <el-divider></el-divider> -->
          <el-form-item label="听课人">
              <el-input v-model="formInline.lecturesUser" placeholder="听课人"></el-input>
          </el-form-item>
          <el-form-item v-show="false" label="用户名">
              <el-input v-model="formInline.username" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item label="职务">
              <el-input v-model="formInline.position" placeholder="职务"></el-input>
          </el-form-item>
            <el-form-item label="时间">
              <el-input v-model="formInline.writDate" placeholder="时间"></el-input>
          </el-form-item>
          <!-- <el-form-item label="时间">
              <el-select v-model="formInline.region" placeholder="时间">
              <el-option label="8:00-8:45" value="1"></el-option>
              <el-option label="9:00-9:45" value="2"></el-option>
              <el-option label="10:00-10:45" value="3"></el-option>
      
              </el-select>
          </el-form-item> -->
             <!-- <el-divider></el-divider> -->
          </el-form>
      </div>
  </div>
     <div class="actionButton" v-loading="loading">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <!-- <el-divider></el-divider> -->
              <el-button type="primary" @click="downs">临时保存</el-button>
              <el-button type="primary" @click="dialogVisible=true">报告预览</el-button>
              <el-button type="primary" @click="onSubmit">确认提交</el-button>
              <el-button type="primary" @click="reset">清空再填</el-button>
              <!-- <el-button type="primary" @click="clear">取消</el-button> -->
              
  
          </el-form>
      </div>
      
  
    <el-dialog
  :visible.sync="dialogVisible"
  width="90%"
 >
<ViewLectures :formInline="formInline"></ViewLectures>
<el-button type="primary" @click="onSubmit">提交</el-button>
<el-button type=" primary" @click="dialogVisible=false">取消</el-button>
</el-dialog>
  </div>
  
  
  </template>
  
  <script>
    import ViewLectures from '@/components/work/teacher/ViewLectures.vue'
     import { Notification } from 'element-ui';
  export default {
    components:{ViewLectures},
    created(){
        this.getLectures()
    },
  data() {
        return {
         dialogVisible:false,
         loading:false,
         notifyPromise:Promise.resolve(),
          formInline: {
            teacher:'',
            teacherUnit:'',
            teacherTitle:'',
            teacherAgeLevel:'',
            courseTitle:'',
            courseType:'',
            lecturesData :'',
            section :'',
            lecturesClass   :'',  
            lecturesAddress  :'',   
            lecturesContent :'', 
            respectStudents  :'',  
            teacheringZeal  :'',   
            target     :'', 
            viewpoint  :'',      
            enrich     :'',
            practical  :'',  
            interaction:'',  
            rationalUtilization   :'',
            understand:'',
            capacity   :'',
          instructionComprehensive :'',      
          courseContent:'',
          discipline  :'',  
          lectures   :'',  
          think  :'',      
          listenComprehensive :'', 
          evaluateComprehensive :'',  
          problem  :'',
          lecturesUser  :'',  
          position    :'',     
          writDate:'' , 
          comment1:'', 
          comment2:'',  
          comment3:'',  
          comment4:'',  
          comment5:'',  
          comment6:'',  
          comment7:'',  
          comment8:'',  
          comment9:'',  
          comment10:'',  
          comment11:'',  
          comment12:'',  
          comment13:'',   
          comment14:'',  
          comment15:'',  
          comment16:'',  
          username:''
        },
      }

},methods:{
    onSubmit(){
        this.formInline.username=JSON.parse(localStorage.getItem('user')).username
    let boolean=this.getVis()
    if(boolean==false){
        return 
    }
        const that=this
        this.$confirm("确定提交？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "success",//提示类型  success/info/warning/error
      }).then(function(){  
        that.loading=true
        let config = {headers: { "Content-Type": "application/json" }}; 
        that.axios.post("/lectures/insertLectures",that.formInline,config)
        .then((resp) => {
          if (resp.data.status == 1) {
            that.loading=false
                 alert("添加成功")
                 that.$message.success("添加成功");
          } else {
            alert("拿取数据失败");
            that.loading=false
          }
        })
        .catch((err) => {
            that.$message.error("出错");
            that.loading=false
        });

      }).catch(()=>{});
    

    },downs(){
       let userid= JSON.parse(localStorage.getItem("user")).userid
       localStorage.setItem('formInline'+userid, JSON.stringify(this.formInline));
       if(localStorage.getItem("formInline"+userid)!=null){
        this.$message.success("保存成功")
       }
    },getLectures(){
        let userid= JSON.parse(localStorage.getItem("user")).userid
       if(localStorage.getItem("formInline"+userid)!=null){
       this.formInline=JSON.parse(localStorage.getItem("formInline"+userid)) 
       }
    },reset(){
        this.formInline={}
        let userid= JSON.parse(localStorage.getItem("user")).userid
        if(localStorage.getItem("formInline"+userid)!=null){
             localStorage.removeItem("formInline"+userid)
             this.$message.success("清空完成")
        }},
        getVis(){
            let boolean=true
            let demo=this.formInline
           if(demo.teacher==null||demo.teacher==''){boolean=false 
            this.getmessage('请输入授课老师')}
            if(demo.teacherUnit==null||demo.teacherUnit==''){boolean=false 
            this.getmessage('请输入所在单位')}
            if(demo.teacherTitle==null||demo.teacherTitle==''){boolean=false 
            this.getmessage('请输入教师职称')}
            if(demo.teacherAgeLevel==null||demo.teacherAgeLevel==''){boolean=false 
            this.getmessage('请选择年龄层次')}
            if(demo.courseTitle==null||demo.courseTitle==''){boolean=false 
            this.getmessage('请输入课程名称')}
            if(demo.courseType==null||demo.courseType==''){boolean=false 
            this.getmessage('请选择课程类型')}
            if(demo.lecturesData==null||demo.lecturesData==''){boolean=false 
            this.getmessage('请输入授课日期')}
            if(demo.section==null||demo.section==''){boolean=false 
            this.getmessage('请选择节次')}
            if(demo.lecturesClass==null||demo.lecturesClass==''){boolean=false 
            this.getmessage('请输入授课班级')}
            if(demo.lecturesAddress==null||demo.lecturesAddress==''){boolean=false 
            this.getmessage('请输入授课地点')}
            if(demo.lecturesContent==null||demo.lecturesContent==''){boolean=false 
            this.getmessage('请输入课程主要内容')}
            if(demo.respectStudents==null||demo.respectStudents==''){boolean=false 
            this.getmessage('请选择尊重学生，治学严谨')}
            if(demo.teacheringZeal==null||demo.teacheringZeal==''){boolean=false 
            this.getmessage('请选择讲课有热情、精神饱满')}
            if(demo.target==null||demo.target==''){boolean=false 
            this.getmessage('请选择教学目标明确、进度适宜')}
            if(demo.viewpoint==null||demo.viewpoint==''){boolean=false 
            this.getmessage('请选择观点正确、表达清晰')}
            if(demo.enrich==null||demo.enrich==''){boolean=false 
            this.getmessage('请选择内容充实，信息量大、重点突出、注意介绍本学科研究和发展动态')}
            if(demo.practical==null||demo.practical==''){boolean=false 
            this.getmessage('请选择理论联系实际、善于启发思维')}
            if(demo.interaction==null||demo.interaction==''){boolean=false 
            this.getmessage('请选择能够实现师生互动、课堂气氛活跃')}
            if(demo.rationalUtilization==null||demo.rationalUtilization==''){boolean=false 
            this.getmessage('请选择能有效利用各种教学媒体')}
            if(demo.understand==null||demo.understand==''){boolean=false 
            this.getmessage('请选择学生理解和掌握了教学内容')}
            if(demo.capacity==null||demo.capacity==''){boolean=false 
            this.getmessage('请选择学生相关能力得到培养和提高')}
            if(demo.instructionComprehensive==null||demo.instructionComprehensive==''){boolean=false 
            this.getmessage('请选择对教师授课情况的综合评价')}
            if(demo.discipline==null||demo.discipline==''){boolean=false 
            this.getmessage('请输入遵守纪律，不迟到、不早退、出勤率高、课堂秩序良好')}
            if(demo.lectures==null||demo.lectures==''){boolean=false 
            this.getmessage('请输入认真听课、记笔记')}
            if(demo.think==null||demo.think==''){boolean=false 
            this.getmessage('请输入对课堂内容感兴趣，积极思考，听课率高')}
            if(demo.listenComprehensive==null||demo.listenComprehensive==''){boolean=false 
            this.getmessage('请输入对学生上课情况的综合评价')}
            if(demo.evaluateComprehensive==null||demo.evaluateComprehensive==''){boolean=false 
            this.getmessage('请选择总体评价')}
            if(demo.problem==null||demo.problem==''){boolean=false 
            this.getmessage('请输入存在问题及改进建议')}
            if(demo.lecturesUser==null||demo.lecturesUser==''){boolean=false 
            this.getmessage('请输入听课人')}
            if(demo.position==null||demo.position==''){boolean=false 
            this.getmessage('请输入职务')}
            if(demo.writDate==null||demo.writDate==''){boolean=false 
            this.getmessage('请输入时间')}
            return boolean
        },

        getmessage(message){
        //     const h = this.$createElement;
        //     this.$notify({
        //   title: '提示',
        //   type: 'warning',
        //   message: h('i', { style: 'color: red'}, message)
        // });

        this.notifyPromise = this.notifyPromise.then(this.$nextTick).then(()=>{
          Notification.warning({
          title: '提示',
          message: message,
          showClose: false
        });
    })
    

        }
}
}
  </script>
  
  <style scoped>
  
  .fillform{
  
      width:100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      border: 1px;
      padding-top: 30px;
  }
  .oneline{
      display: flex;
      flex-direction: column;
      /* height:100px; */
  }
  .singleinput{
      width:200px;
      height:20px ;
      margin-top: 15px;
      margin-left: 45px;
  }
  
  .multiinput{
      width:800px;
      height:80px ;
        margin-top: 15px;
      margin-left: 35px;
  }
  .metainfo
  {
      width:100%;
      height: 100px;
      display: flex;
      border: 2px;
      flex-direction: column;
  
  
  }
  .metainfo1
  {
      width:400px;
      height: 45px;
      display: flex;
      border: 1px;
  
  }
  .leftform_T{
      width:120px;
      height:900px;
        padding:10px;
      background-color:rgb(185, 212, 203);
      /* text-align:justify;
      vertical-align:middle; */
  }
  .leftform_S{
      width:270px;
      height:250px;
       padding:10px;
       padding-right:30px;
      background-color:rgb(202, 230, 219);
  }
  
  .leftform_All{
        width:270px;
      height:40px;
       padding:10px;
       padding-right:30px;
      background-color:rgb(107, 146, 130);
  }
  .midform_T{
      width:150px;
      height:900px;;
      padding:10px;
      background-color:rgba(153, 194, 197, 0.418);
  }
  .Rightform_T{
      width: 930px!important;
      height:900px;
      padding:10px;
      background-color:rgba(186, 230, 233, 0.418);
  }
  .Rightform_S{
      width:930px;
      height:250px;;
      padding:10px;
      background-color:rgba(186, 230, 233, 0.618);
  }
  .Rightform_All{
      width:930px;
      height:40px;;
      padding:10px;
      background-color:rgba(128, 161, 163, 0.418);
  }
  .midform_S{
     width:150px;
      height:400px;;
      padding:10px;
      background-color:rgba(153, 194, 197, 0.418);
  }
  .eachquestionform{
      width: 40%;
      height:40%;
      display: flex;
      flex-direction: column;
  }
  .assessformTeacher
  {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 1000px;
      padding-top:0px;
  
      
  }
  .assessformstudent
  {
      display: flex;
      flex-direction: row;
      width: 100%;
      height: 40%;
  
  
      
  }
  .textvert{
      padding-top: 200px;
  }
  .metainfoFeedback
  {
      width:100%;
      height: 120px;
      display: flex;
       flex-direction: column;
      border: 1px;
      margin-top:15px;
  }
  .actionButton{
  
      display: flex;
      padding-left:400px;
      padding-bottom: 20px;
      padding-top: 20px;
      
  }
  
  
  .item .el-form-item__label{
          color: #aaaa33;
      }
  .label-content .el-form-item__content{
          font-size: 20px;
          color: #aaaa33;
      }
  el-form-item >>>.el-form-item__label{
          color: #aaaa33;
      }
  .label-content .el-form-item__content{
          font-size: 20px;
          color: #aaaa33;
      }

.mainHeader{
        background-color: rgb(235, 226, 228);
        padding-top: 30px; 
    }
  
  </style>
  
  
  
  


// WEBPACK FOOTER //
// src/components/work/teacher/Lectures.vue